import React from 'react';
import { useRiskScoreResultsStore } from '../../../mothership/riskScoresResults.state';

export const RiskScoresTableInfo = () => {
  const totalElements = useRiskScoreResultsStore((state) => {
    return state.totalElements;
  }).toLocaleString();

  const visibleRowCount = useRiskScoreResultsStore((state) => {
    return state.riskScoreTableData;
  }).length.toLocaleString();

  return (
    <div className="dfedsTableInfoContainer">
      <div
        className="dfedsTableInfo"
        data-cy="riskScoresTableInfo"
        data-testid="riskScoresTableInfo"
      >
        {`Showing 1 – ${visibleRowCount} of ${totalElements} results`}
      </div>
    </div>
  );
};
